import React from 'react';
import GATrackingIdForm from 'FeatureModules/Setting/Components/Forms/GATrackingIdForm';
import { UPDATE_COMPANY_CONFIGS } from 'graphql/secure/mutations';
import { useMutation, useQuery } from '@apollo/client';
import { GET_COMPANY_DETAILS } from 'graphql/secure/queries';
import ErrorState from 'Components/ErrorState';
import Loader from 'Components/Forms/Loader';
import useMessages from 'hooks/useMessages';
import Container from '../Components/Container';
import SettingsHeader from '../Components/SettingsHeader';

const GoogleAnalyticsTrackingId = () => {
  const { data: { company } = {}, error, loading } = useQuery(GET_COMPANY_DETAILS);

  const { setSuccessMessage, setErrorMessage } = useMessages();
  const [updateCompanyConfigs] = useMutation(UPDATE_COMPANY_CONFIGS, {
    onCompleted: () => {
      setSuccessMessage('Success! Google Analytics tacking id was updated.');
    },
    onError: () => {
      setErrorMessage('Something went wrong updating your Google Analytics tracking id.');
    },
  });

  const handleSubmit = ({ gaTrackingId }) => {
    return updateCompanyConfigs({
      variables: {
        input: {
          gaTrackingId,
        },
      },
    });
  };

  if (error) return <ErrorState error={error} />;
  if (!company && loading) return <Loader />;

  return (
    <Container>
      <SettingsHeader title="Google Analytics Tracking ID" />
      <GATrackingIdForm onSubmit={handleSubmit} gaTrackingId={company?.gaTrackingId} />
    </Container>
  );
};

export default GoogleAnalyticsTrackingId;
